/*
 fetch-methoddetails
 Last method is any of the methods described in 'paymentMethods' module.

 an alternative name for this module is:
 "fetch-methoddetails"
 */
import actions from '../../common/lib/utils/actions.js';
import constants from '../../common/lib/utils/constants.js';
import core from '../../common/lib/core.js';
import dataflow from '../../common/lib/dataflow.js';
import view from './view.js';
import methodIdToName from './deposit-form-template-conf.js';

const register = dataflow.register;
const state = {
	accounts: {
		by_id: {}
	},
	creditcardlast: null,
	selectedAccountIdx: null,
	lastAmount: null
};

function viewUpdate() {
	view.update({
		fetch_methoddetails: state
	});
}

function sortById(accounts) {
	const byId = {};
	if (accounts) {
		accounts.forEach((elm) => {
			if (elm.id) {
				byId[elm.id] = elm;
			}
		});
	}
	return byId;
}

function filterAccountResponse(data) {
	const hasAccounts = (data && data.hasAccounts);
	const currencies = (data && data.currencies);
	const accounts = (data && data.accounts);
	const accountsById = sortById(accounts);
	const lastUsedAccountIdx = ((data && (data.lastUsedAccountIdx || data.lastUsedAccountIdx === 0)) ? data.lastUsedAccountIdx : null);
	const lastAccount = (((lastUsedAccountIdx || lastUsedAccountIdx === 0) && accounts) && accounts[lastUsedAccountIdx]);
	const lastAmount = (lastAccount && lastAccount.amount);
	const lastCardNo = (lastAccount && lastAccount.cardNo);
	const lastCardId = (lastAccount && lastAccount.id);
	return {
		accounts,
		accountsById,
		currencies,
		selectedAccountIdx: lastUsedAccountIdx,
		lastUsedAccountIdx,
		selectedAccount: lastAccount,
		lastAmount,
		creditcardlast: lastCardNo,
		lastCardId,
		lastCardNo,
		hasAccounts
	};
}

function getDataAndReplaceState(url, params, methodName) {
	state.error = null;

	function successHandler(data) {
		// TODO: merge the 'filterAccountResponse' with this 'successHandler'
		const res = filterAccountResponse(data);
		const accounts = res.accounts || {};
		const currencies = res.currencies || {};
		const lastUsedAccountIdx = res.lastUsedAccountIdx;
		const lastAmount = res.lastAmount;
		const creditcardlast = res.creditcardlast;
		const hasAccounts = res.hasAccounts;
		const lastCardId = res.lastCardId;
		accounts.by_id = res.accountsById;

		state.accounts = accounts; /* used in view-creditcard*/
		state.currencies = currencies;
		state.lastAmount = lastAmount;
		state.creditcardlast = creditcardlast; // the number like '***********1111'
		state.lastCardId = lastCardId;
		state.accountId = lastUsedAccountIdx;
		state.lastUsedAccountIdx = lastUsedAccountIdx;
		state.selectedAccountIdx = lastUsedAccountIdx; /* used in view-creditcardlast*/
		state.hasAccounts = hasAccounts;
		actions.fetchMethodDetails(state);
		viewUpdate();
	}

	function errorHandler(err) {
		console.error('fetch-methoddetails:57:failure:', err);
		state.error = `:${methodName}`; // contains a ':' (colon) to give true from Boolean(state.error)
		viewUpdate();
	}

	if (url) {
		core.post(url, params, successHandler, errorHandler, 'application/x-www-form-urlencoded; charset=UTF-8');
	} else {
		// Pretend we fetched form data so that we set some state without accounts and sends the right action
		successHandler({
			hasAccounts: false,
			lastAmount: 0
		});
	}
}

function getFormTemplateData(url, params, methodName, methodId, formTemplateCode) {
	if (methodIdToName.isValid(formTemplateCode)) { /* confirm that a module exist for the selected method */
		const allParams = `isMobile=true${params}`;
		getDataAndReplaceState(url, allParams, methodName);
	} else {
		console.warn('fetch-methoddetails:146:getFormTemplateData: no valid method id provided for returning deposit:', methodId);
	}
}

function registerActions() {
	function fetchMethodDetails(payload) {
		let currentAccount = null;
		let currentCardNo = null;
		if (payload.type === constants.PAYMENTMETHODS) {
			/* see structure of data in 'paymentmethods module' */
			/* when a new method is selected the paymentmethods.js-module updates
			and this action is recieved*/
			const currentPaymentMethodId = (payload.data && payload.data.selectedId);
			if (payload.data) {
				const formTemplateUrl = (payload.data && payload.data.selectedDetailsUrl);
				const methodName = (payload.data && payload.data.selectedMethodName);
				const params = (payload.data && payload.data.selectedDetailsParams);
				const formTemplateCode = payload.data.methods.by_id[currentPaymentMethodId].formTemplateCode;
				getFormTemplateData(formTemplateUrl, params, methodName, currentPaymentMethodId, formTemplateCode);
			} else {
				console.warn('fetch-methoddetails:137:registerActions: PAYMENTMETHODS: no property "data" of payload', payload);
			}
		}
		if (payload.type === constants.VIEW_METHODS) {
			// method change: reset parameters and wait for paymentMethods to update.
			state.accounts = null; /* used in view-creditcard*/
			state.currencies = null;
			state.lastAmount = null;
			state.creditcardlast = null; // the number like '***********1111'
			state.lastCardId = null;
			state.accountId = null;
			state.lastUsedAccountIdx = null;
			state.selectedAccountIdx = null; /* used in view-creditcardlast*/
			state.hasAccounts = null;
		}

		if (payload.type === constants.VIEW_CREDITCARDLAST) {
			currentAccount = payload.data;
			currentCardNo = (currentAccount && currentAccount.cn);
			state.creditcardlast = currentCardNo;
			viewUpdate();
		}
	}

	register(fetchMethodDetails);
}

export default {
	init() {
		registerActions();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/fetch-methoddetails.js